export const checkIfComponentHasDarkBg = (currentPageComponentBackgroundTitle:any) => {
    // see componentsBackgroundColorsOptions.ts for the values.
    // If dark bg - recolor text/icons/inputs etc to white.
    if(currentPageComponentBackgroundTitle === 'black' || currentPageComponentBackgroundTitle === 'accent' || currentPageComponentBackgroundTitle === 'mature'){
        return true;
    }else{
        return false;
    }
};